Auth = require 'db/auth'
_ = require 'underscore'
LDClient = require 'ldclient-js'
Visibility = require 'visibilityjs'

initialUserOpts = {
  key: Auth.myId(),
  anonymous: !Auth.isLoggedIn(),
}

class LaunchDarklyClient
  constructor: (userOpts = {}, bootstrap = 'localStorage') ->
    user = _.extend userOpts, initialUserOpts
    @client = LDClient.initialize window.launchdarklyKey,
      user,
      { bootstrap }

    for method, func of @client
      @[method] = func

    @listen()

  listen: ->
    window.addEventListener 'online',  =>
      # wait ten seconds to give the network more time to reconnect
      window.setTimeout =>
        @client.identify initialUserOpts, null
      , 10000

    Visibility.change =>
      if !Visibility.hidden()

        window.setTimeout =>
          @client.identify initialUserOpts, null
        , 1000


  updateUserInfo: ->
    orgList = _.map Auth.me()?.getSortedOrgs(),
      (x) -> x.attributes.displayName

    user = _.extend {
      'custom': {
        'channel': Auth.me().get('channels')?.active,
        'orgs': orgList
      }
    }, initialUserOpts

    @identify user

module.exports = new LaunchDarklyClient()



// WEBPACK FOOTER //
// ./app/scripts/lib/ldclient.coffee